import './indexComponent.css';
// import { NavBarComponent } from '../navBarComponents/navBarComponent';
import {CodeEditor} from '../resultComponents/resultComponent';
export function IndexComponent(){
     return (
  <>
    <section>
      {/* <NavBarComponent></NavBarComponent> */}
      <CodeEditor></CodeEditor>
    </section>
  </>
);

}